import handleHamburgerClick from './handleHamburgerClick';
import renderAds from './adDisplay';
import setSticky from './setSticky';
import setCurrentYear from './setCurrentYear';

// eslint-disable-next-line import/no-unassigned-import -- Introduced in TP-9489.
import '../../css/example-page/example-page.less';

/* Team jQuery */
const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);

const init = () => {
	// Check if we're loaded in an iframe
	const isInIframe = window.location !== window.parent.location;

	// If not, wrap it in the iframe
	if (!isInIframe) {
		window.location.assign(
			window.location.protocol + '//' + window.location.host + '/example-page',
		);
	}

	$('.Exp-hamburger').addEventListener('click', handleHamburgerClick);

	const adSwitcherButtons = Array.from($$('.Exp-nav-ad-switcher'));

	adSwitcherButtons.forEach((switcher) => {
		switcher.addEventListener('click', (event) => {
			const switcherType = event.target.dataset.adSwitcher;

			adSwitcherButtons.forEach((el) => el.classList.remove('_active'));
			event.target.classList.add('_active');
			renderAds(switcherType, switcherType === 'banner');
			setSticky($('[data-zoneid="7"]'));
			handleHamburgerClick();
		});
	});

	renderAds(); // Render all ads at random on page load
	setSticky($('[data-zoneid="7"]')); // Makes skyscraper sticky
	setCurrentYear($('.current-year')); // Forever up to date
};

init();
